import { render, staticRenderFns } from "./comptajournal.vue?vue&type=template&id=5833b5a7&"
import script from "./comptajournal.vue?vue&type=script&lang=js&"
export * from "./comptajournal.vue?vue&type=script&lang=js&"
import style0 from "./comptajournal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports